import {
  GENERIC_ERROR_MESSAGE_FALLBACK,
  GENERIC_ERROR_STATUS,
  GENERIC_ERROR_TRANSLATION_KEY,
} from '@shared/utils/constants/errors';

export const postEmailWithVisaLetterPdf = async ({
  encodedPdf,
  recipientEmail,
  recipientName,
  visaLetterType,
}: {
  encodedPdf: string;
  recipientEmail: string;
  recipientName: string;
  visaLetterType: Nullable<string>;
}) => {
  try {
    const response = await fetch(`/api/sendgrid/visa-letter`, {
      body: JSON.stringify({
        encodedPdf,
        recipientEmail,
        recipientName,
        visaLetterType,
      }),
      method: 'POST',
    });

    if (response.status !== 200) {
      const resolvedResponse = await response.json();

      return {
        message: resolvedResponse.message || response.statusText,
        messageTranslationKey: resolvedResponse.messageTranslationKey || '',
        status: response.status,
      };
    }

    return { status: 200 };
  } catch {
    return {
      message: GENERIC_ERROR_MESSAGE_FALLBACK,
      messageTranslationKey: GENERIC_ERROR_TRANSLATION_KEY,
      status: GENERIC_ERROR_STATUS,
    };
  }
};
